import { Grid } from '@mui/material'
import React from 'react'

const GlobalList = ({ children }) => {
  return (
    <>
        <Grid container>
            {children}
        </Grid>
    </>
  )
}

export default GlobalList